import {
  SingleChoiceComposedElement,
  SingleChoiceQuestionConfig,
} from '@hyper-inferno/single-choice-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import {
  BaseComposedElement,
  QuestionAnswerObject,
  QuestionType,
  SurveyElement,
} from '@hyper-inferno/survey-elements-core';

export class SingleChoiceHandler
  implements QuestionHandler<SingleChoiceQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }

  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    const key = el.name;
    return [(response[key] as number) ?? 0]; // returns number
  }

  /**
   * A single choice with one selectable option is a forced answer, and with no
   * selectable option it can only be answered empty. Everything else needs the
   * respondent.
   */

  handleAutoCode(
    el: SurveyElement,
    ctx: ITransformationContext,
    composedElement: BaseComposedElement,
  ): QuestionAnswerObject | null {
    const config = (composedElement as SingleChoiceComposedElement)[
      QuestionType.SINGLE_CHOICE
    ] as SingleChoiceQuestionConfig | undefined;

    if (!config) return null;

    const options = config.options ?? [];

    // Exclude AFM placeholders and options that are hidden or disabled.
    const selectableOptions = options.filter(
      (option) => !option.is_afm_trigger && !option.hidden && !option.disabled,
    );

    // No selectable options: submit an empty answer.
    if (selectableOptions.length === 0) {
      return {};
    }

    // A single available option can be auto-coded.
    if (selectableOptions.length === 1) {
      const onlyOption = selectableOptions[0];

      // Open-ended options require respondent input.
      if (onlyOption.is_open_ended) {
        return null;
      }

      return {
        [el.name]: onlyOption.option_key,
      };
    }

    // Multiple available options require respondent input.
    return null;
  }
}
